import { TAdminPanelConfig } from './AdminPanel.types';
import { PhoneCases } from './components/PhoneCases/PhoneCases';
import { Localization } from './components/Localization/Localization';
import { Tag } from './components/Tag/Tag';
import { Stock } from './components/Stock/Stock';
import { Orders } from './components/Orders/Orders';

export const ADMIN_PANEL_CONFIG: TAdminPanelConfig = [
  {
    id: 'stock',
    displayName: 'Stock',
    children: [
      {
        id: 'stock-items',
        displayName: 'Stock',
        ConfigPage: Stock,
      },
    ],
  },
  {
    id: 'orders',
    displayName: 'Orders',
    children: [
      {
        id: 'orders-items',
        displayName: 'Orders',
        ConfigPage: Orders,
      },
    ],
  },
  {
    id: 'phone-cases',
    displayName: 'Phone cases',
    children: [
      {
        id: 'phone-cases-items',
        displayName: 'Phone cases items',
        ConfigPage: PhoneCases,
      },
    ],
  },
  {
    id: 'tags',
    displayName: 'Tags',
    children: [
      {
        id: 'tags-items',
        displayName: 'Tags',
        ConfigPage: Tag,
      },
    ],
  },
  {
    id: 'localization',
    displayName: 'Static Localization',
    children: [
      {
        id: 'localization-items',
        displayName: 'Localization',
        ConfigPage: Localization,
      },
    ],
  },
];
